import { RenderIndicator, getDOMInfo } from '@ws-ui/craftjs-utils';
import React, { useEffect } from 'react';

import { useEventHandler } from './EventContext';
import movePlaceholder from './movePlaceholder';

import { useInternalEditor } from '../editor/useInternalEditor';

export const RenderEditorIndicator = () => {
  const { indicator, indicatorOptions, enabled, nodes } = useInternalEditor(
    (state) => ({
      indicator: state.indicator,
      indicatorOptions: state.options.indicator,
      enabled: state.options.enabled,
      nodes: state.nodes,
    })
  );

  const handler = useEventHandler();

  useEffect(() => {
    if (!handler) {
      return;
    }

    if (!enabled) {
      handler.disable();
      return;
    }

    handler.enable();
  }, [enabled, handler]);

  if (!indicator) {
    return null;
  }

  function getClosestNoneHiddenNode() {
    let count = 1;

    while (true) {
      const prevNodeId =
        indicator.placement.parent.data.nodes[
          indicator.placement.index - count
        ];

      if (!nodes[prevNodeId]) return null;

      if (!nodes[prevNodeId].dom.classList.contains('hidden'))
        return nodes[prevNodeId];

      count++;
    }
  }

  const closestNoneHiddenNode = getClosestNoneHiddenNode();

  return React.createElement(RenderIndicator, {
    className: indicatorOptions.className,
    style: {
      ...movePlaceholder(
        indicator.placement,
        getDOMInfo(indicator.placement.parent?.dom),
        indicator.placement.currentNode?.dom &&
          !indicator.placement.currentNode.dom.classList.contains('hidden')
          ? getDOMInfo(indicator.placement.currentNode?.dom)
          : closestNoneHiddenNode
          ? getDOMInfo(closestNoneHiddenNode?.dom)
          : null,
        indicatorOptions.thickness
      ),
      backgroundColor: indicator.error
        ? indicatorOptions.error
        : indicatorOptions.success,
      transition: indicatorOptions.transition || '0.2s ease-in',
      ...(indicatorOptions.style ?? {}),
    },
    parentDom: indicator.placement.parent.dom,
  });
};
